export default {
  rowLabel: "contract {{number}}",
  contracts: "Contracts",
  newContract: "New contract",
  columns: {
    title: "Title",
    contractNumber: "Contract no.",
    status: "Status",
    signers: "Signers",
    updated: "Updated",
    actions: "Actions",
  },
  status: {
    draft: "Draft",
    sent: "Sent",
    partially_signed: "Partially signed",
    executed: "Executed",
    voided: "Voided",
  },
  type: {
    signature_only: "Signature only",
    client_agreement: "Client agreement",
    client_contract: "Client contract",
  },
  promote: {
    prompt: "This contract doesn't have billing.",
    action: "Set it up",
    title: "Add Billing",
    description:
      "Add what billing needs. Once billing is added, it can't be removed.",
    clientRequired: "Select a client.",
    currencyRequired: "Select a currency.",
    submit: "Add Billing",
    cancel: "Cancel",
    failed: "Billing could not be added. Please try again.",
  },
  rowActions: {
    menuLabel: "Contract actions",
    view: "View",
    send: "Send for signing",
    resend: "Resend for signing",
    downloadSealed: "Download sealed copy",
    downloadCertificate: "Download certificate",
    delete: "Delete",
  },
  empty: {
    title: "No contracts yet",
    subtitle:
      "Send a finished PDF out for e-signature — Invup tracks every signer and seals the executed copy.",
  },
  modal: {
    title: "New Contract",
    subtitle:
      "Choose its type, add the document, then fill in what that type needs.",
  },
  create: {
    stepsLabel: "Steps",
    stepType: "Type",
    stepDocument: "Document",
    stepDetails: "Details",
    stepCompleted: "completed",
    typeLegend: "What kind of contract is this?",
    types: {
      signatureOnly: {
        label: "Signature Only",
        description: "A document to be signed. No client record, no billing.",
      },
      clientAgreement: {
        label: "Client Agreement",
        description: "Belongs to a client, but no money moves through it.",
      },
      clientContract: {
        label: "Client Contract",
        description: "Belongs to a client and generates invoices.",
      },
    },
    typeRequired: "Choose a contract type.",
    documentHeading: "Add the document",
    documentHelp: "Upload the finished PDF or Word file people will sign.",
    documentHelpWithTitle:
      "Upload the finished PDF or Word file, then give the contract a title.",
    document: "Document",
    documentPlaceholder: "Choose a file or drag it here",
    documentHint: "PDF or DOCX · up to {{size}} MB",
    documentRequired: "Upload a PDF or Word document.",
    uploadInProgress: "Wait for the upload to finish before continuing.",
    detailsHeading: "Contract details",
    detailsHelpAgreement:
      "A client agreement needs a title and the client it belongs to.",
    detailsHelpContract:
      "A client contract needs a title, a client and a currency. You’ll add line items on the Billing tab next.",
    contractTitle: "Contract Title",
    contractTitlePlaceholder: "e.g. Master services agreement",
    titleRequired: "Enter a contract title.",
    client: "Client",
    clientHintAgreement: "The client this agreement belongs to.",
    clientRequired: "Choose a client.",
    clientsLoading: "Loading clients...",
    clientsLoadFailedTitle: "Clients could not be loaded",
    clientsLoadFailed:
      "Sorry, the client list could not be loaded due to an error on our end. Please try again.",
    clientsForbiddenTitle: "You can’t view clients",
    clientsForbidden:
      "Your role can’t see the client list. Ask an organization admin for access, or change the type to Signature Only.",
    tryAgain: "Try Again",
    currencyRequired: "Choose a currency.",
    noClientsTitle: "No clients yet",
    noClientsBody:
      "This type of contract belongs to a client. Add a client in the new tab, then choose Check Again to pick it here.",
    noClientsBodyNoPermission:
      "This type of contract belongs to a client, and your role can’t add clients. Ask an organization admin to add one, or change the type to Signature Only.",
    addClient: "Add Client",
    addClientAccessible: "Add Client (opens in a new tab)",
    checkAgain: "Check Again",
    clientsUpdated: "Client list updated.",
    stillNoClients: "Still no clients.",
    changeType: "Change Type",
    back: "Back",
    next: "Next",
    submit: "Create Contract",
    submitting: "Creating the contract...",
    failedTitle: "This contract could not be created",
    failedServer:
      "Sorry, this contract could not be created due to an error on our end. Please try again.",
    created: "Contract created successfully",
    createdBilling: "Add line items and a payment schedule on the Billing tab.",
    createdDocument: "Add signers and place their fields on the document.",
    openBilling: "Open Billing",
    openContract: "Open Contract",
  },
  send: {
    title: "Send for signing",
    subtitle: "Each signer gets their own private link to sign.",
    ownInbox: "own inbox",
    sharedInbox: "shared inbox",
    roleTitle: "Shared inboxes can’t sign",
    roleBody:
      "Every signer must be a named person with their own inbox. Replace shared addresses like billing@ or info@ before sending.",
    incompleteTitle: "Not ready to send",
    warningsTitle: "Check before you send",
    cancel: "Cancel",
    send: "Send",
    sendFailed:
      "Sorry, this contract could not be sent due to an error on our end. Please try again later.",
    successTitle: "Sent for signing",
    successBodyOne: "Sent to {{count}} signer — this contract is now locked.",
    successBodyOther:
      "Sent to {{count}} signers — this contract is now locked.",
    sentLocked: "sent · locked",
  },
  resend: {
    title: "Resend for signing",
    confirm: "Resend",
    confirmAll: "Resend the signing link to everyone who hasn’t signed yet?",
    confirmSigner: "Resend the signing link to {{name}}?",
    resendAll: "Resend all",
  },
  editor: {
    back: "Back to contracts",
    send: "Send",
    signers: "Signers",
    fields: "Fields",
    selectedField: "Selected field",
    addSigner: "Add signer",
    addSignerFirst: "Add a signer before placing fields.",
    cancel: "Cancel",
    add: "Add",
    fieldsHint: "Add a field, then drag it into place and assign a signer.",
    inspectorEmpty:
      "Select a field on the page to edit its type, page and assigned signer.",
    type: "Type",
    pageLabel: "Page",
    assignTo: "Assign to signer",
    removeField: "Remove field",
    removeSigner: "Remove signer",
    resendSigner: "Resend to this signer",
    signed: "Signed",
    namePlaceholder: "e.g. Priya Natarajan",
    emailPlaceholder: "name@company.com",
    signerForbidden: "You don’t have permission to add this signer.",
    signerSaveFailed:
      "Sorry, this signer could not be added due to an error on our end. Please try again later.",
    nameLabel: "Name",
    emailLabel: "Email",
    signerContacts: {
      pickerLabel: "Choose from {{client}}’s contacts",
      pickerPlaceholder: "Search contacts",
      sharedInbox: "Shared inbox",
      orByHand: "Or enter someone else",
      noContacts: "{{client}} has no contacts yet. Enter the signer below.",
      loadFailed:
        "Sorry, {{client}}’s contacts couldn’t be loaded due to an error on our end. Enter the signer below.",
      notOnList: "This address isn’t on {{client}}’s contact list.",
      saveToClient: "Save to Contacts",
      dontSave: "Don’t Save",
      saved: "Contact saved successfully",
      dismissNotice: "Dismiss",
    },
    zoomIn: "Zoom In",
    zoomOut: "Zoom Out",
    hintTitle: "Almost ready to send",
    hintBody: "Add a signer and place at least one field before sending.",
    unassigned: "Unassigned",
    notFound: "Contract not found.",
    pdfError: "We couldn’t load the document preview.",
    pdfNoText: "This document has no text that can be searched or read aloud.",
    pdfTextUnavailable:
      "We couldn’t read the text in this document, so it can’t be searched or read aloud.",
    pdfDownload: "Download the contract (PDF)",
    pageOfTotal: "Page {{page}} of {{total}}",
    zoomLevel: "Zoom {{percent}} percent",
    zoomMin: "Minimum zoom, {{percent}} percent",
    zoomMax: "Maximum zoom, {{percent}} percent",
    fieldTypes: {
      signature: "Signature",
      initial: "Initial",
      date: "Date",
    },
  },
  executed: {
    executedOn: "Executed",
    headTitle: "This contract is executed",
    headSub:
      "Every signer has signed. The document is sealed and locked — no further changes.",
    details: "Completion record",
    contractNo: "Contract no.",
    signers: "Signers",
    signedOn: "signed",
    fingerprint: "Document fingerprint",
    fingerprintHint: "SHA-256 of the sealed PDF/A",
    timestamp: "Trusted timestamp",
    timestampHint: "Sealed & time-stamped · RFC 3161",
    downloadSealed: "Download sealed copy",
    downloadCertificate: "Download certificate",
    verifyTitle: "Check integrity",
    verifySub:
      "Drop the sealed file to confirm it hasn’t changed since execution. Nothing is uploaded — the file is hashed and compared.",
    drop: "Drop the sealed PDF here",
    dropHint: "or click to choose · re-hashed against the record",
    verifying: "Checking…",
    matchTitle: "This file matches the sealed record",
    matchBody:
      "The SHA-256 of this file is identical to the recorded fingerprint. It has not been altered since execution.",
    mismatchTitle: "This file does not match — it may have been altered",
    mismatchBody:
      "The SHA-256 of this file differs from the recorded fingerprint. Download a fresh sealed copy above.",
    checkAnother: "Check another file",
  },
  billing: {
    tabsLabel: "Contract sections",
    tabDocument: "Document",
    tabBilling: "Billing",
    sectionTitle: "Contract Terms",
    lineItems: "Line Items",
    client: "Client",
    clientHint: "Invoices raised from this contract are billed to this client.",
    clientPlaceholder: "Select a client...",
    currency: "Currency",
    currencyPlaceholder: "Select a currency...",
    currencyHint: "Line items and scheduled payments all use this currency.",
    leadTime: "Invoice Lead Time",
    lockedNote:
      "This contract has been sent, so the client and currency are locked. The invoice lead time can still change.",
    executedNote:
      "This contract is fully signed, so the client and currency are locked. The invoice lead time can still change, and applies to invoices not yet generated.",
    voidedNote: "This contract is voided, so its billing terms are read-only.",
    leadTimeInherit_one: "Organization default — {{count}}",
    leadTimeInherit_other: "Organization default — {{count}}",
    leadTimeUnit_one: "day",
    leadTimeUnit_other: "days",
    leadTimeDays_one: "{{count}} day",
    leadTimeDays_other: "{{count}} days",
    leadTimeOrgDefault_one: "Your organization's default is {{count}} day.",
    leadTimeOrgDefault_other: "Your organization's default is {{count}} days.",
    leadTimeOverride: "Customize",
    leadTimeUseDefault: "Use default",
    leadTimeHelp:
      "Invoices go out this many days before a payment is due. Changing this updates the issue date of every invoice that hasn't been generated yet.",
    leadTimeHelpReadOnly:
      "Invoices go out this many days before a payment is due.",
    leadTimeRange: "Enter a whole number of days between {{min}} and {{max}}.",
    currencyChangeTitle: "Change Currency",
    currencyChangeBody:
      "Changing the currency re-labels every line item and scheduled payment on this contract. The amounts stay the same — only the currency changes.",
    currencyChangeConfirm: "Change Currency",
    columns: {
      sku: "SKU",
      name: "Description",
      quantity: "Qty",
      unitPrice: "Unit price",
      amount: "Amount",
    },
    addItem: "Add Line Item",
    addDisabledTooltip: "Set a currency on this contract before adding items.",
    itemNamePlaceholder: "Item name",
    itemDescriptionPlaceholder: "Description",
    itemNameRequired: "Enter an item name of 100 characters or fewer.",
    itemSkuTooLong: "Enter an SKU of 100 characters or fewer.",
    itemDescriptionTooLong: "Enter a description of 5,000 characters or fewer.",
    itemQuantityInvalid: "Enter a quantity greater than zero.",
    itemUnitPriceInvalid: "Enter a unit price of zero or more.",
    totalLabel: "Total",
    discardItem: "Discard This Row",
    removeItem: "Remove Line Item",
    removeItemTitle: "Remove Line Item",
    removeItemBody: "Are you sure you want to remove “{{name}}”?",
    rowMenuLabel: "Line item actions",
    catalog: {
      addFromCatalog: "Add from Catalog",
      title: "Add from Catalog",
      searchLabel: "Search the catalog",
      searchPlaceholder: "Search by name or SKU",
      selectedHeading_one: "{{count}} product selected",
      selectedHeading_other: "{{count}} products selected",
      removeSelected: "Remove {{name}} from the selection",
      addProducts: "Add Products",
      addSelected_one: "Add {{count}} Product",
      addSelected_other: "Add {{count}} Products",
      wrongCurrency: "Priced in {{currency}}, so it can’t go on this contract.",
      selectionLimit: "You can add up to {{count}} products at a time.",
      empty:
        "Your catalog is empty. Add products in Settings to pick them here.",
      noResults: "No active products match that search.",
      loadFailed: "We couldn’t load your catalog",
      loadFailedBody: "Sorry, this happened on our end. Try again in a moment.",
      adding: "Adding to the contract.",
      added_one: "{{count}} product added",
      added_other: "{{count}} products added",
      addedMessage:
        "Each one is now a line item you can edit without touching your catalog.",
      addFailed: "We couldn’t add those products. Try again in a moment.",
      productUnavailable_one:
        "A product you picked is no longer available. We’ve removed it from your selection.",
      productUnavailable_other:
        "{{count}} products you picked are no longer available. We’ve removed them from your selection.",
    },
    empty: {
      noCurrencyTitle: "Set a currency first",
      noCurrencyBody:
        "A contract needs a currency before it can carry line items. Set one above to start pricing this contract.",
      setCurrency: "Set a Currency",
      noItemsTitle: "No line items yet",
      noItemsBody:
        "The contract value is the sum of its line items. Add the first one to get started.",
    },
    itemsLoadFailed: "We couldn’t load the line items",
    itemsLoadFailedBody:
      "Sorry, this happened on our end. Try again in a moment.",
    retry: "Try Again",
    saveFailed:
      "Sorry, this change could not be saved due to an error on our end. Please try again later.",
    schedule: {
      title: "Payment Schedule",
      columns: {
        description: "Description",
        due: "Payment Due",
        invoice: "Invoice",
        amount: "Amount",
      },
      scheduledTotal: "Scheduled",
      remainder:
        "{{remaining}} of the {{value}} contract value isn’t scheduled yet.",
      overScheduled:
        "The schedule adds up to {{scheduled}}, more than the {{value}} contract value.",
      valueUnknown:
        "Percentage amounts can’t be worked out until the contract value is known.",
      dueOnSigning: "On signing",
      dueAfterSigning_one: "{{count}} day after signing",
      dueAfterSigning_other: "{{count}} days after signing",
      dueOnDate: "On {{date}}",
      invoiceSameDay: "Invoice on the due date",
      invoiceEarlier_one: "Invoice {{count}} day earlier",
      invoiceEarlier_other: "Invoice {{count}} days earlier",
      datesOnceSigned: "Exact dates once signed",
      issuedAndDue: "Issued {{issued}} · due {{due}}",
      generatedOn: "Invoice raised {{at}}",
      warnDueOnArrival:
        "This invoice goes out on the day it’s due, so the client receives it already due.",
      warnShortenedWindow_one:
        "The invoice will go out on the signing date — that’s a {{count}}-day window, not {{lead}}.",
      warnShortenedWindow_other:
        "The invoice will go out on the signing date — that’s a {{count}}-day window, not {{lead}}.",
      leadLabel: "Send the Invoice Before It’s Due",
      leadInherit_one: "Use contract default — {{count}} day",
      leadInherit_other: "Use contract default — {{count}} days",
      leadOverride: "Set a Custom Lead Time",
      leadUseDefault: "Use Contract Default",
      leadHelp:
        "The invoice goes out this many days before the payment is due, moved onto the next working day.",
      addPayment: "Add Payment",
      addDisabledNoClient:
        "Add a client to this contract before scheduling payments.",
      addDisabledNoCurrency:
        "Set a currency on this contract before scheduling payments.",
      addDisabledNoClientOrCurrency:
        "Add a client and set a currency before scheduling payments.",
      addDisabledVoided:
        "This contract is voided, so its schedule is read-only.",
      addDisabledFullyScheduled:
        "The whole contract value is already scheduled. Raise the contract value or edit a payment to make room.",
      fieldDescription: "Description",
      fieldDescriptionPlaceholder: "Deposit...",
      fieldTrigger: "Payment Due",
      triggerAfterSigning: "A number of days after signing",
      triggerFixedDate: "On a fixed date",
      fieldOffsetDays: "Days After Signing",
      offsetHelp:
        "Enter 0 for a payment due on the signing date. Days is the only unit — three months is 90 days.",
      fieldFixedDueDate: "Due Date",
      fieldAmountType: "How Much",
      amountTypeFixed: "A fixed amount",
      amountTypePercentage: "A percentage of the contract value",
      fieldAmount: "Amount",
      fieldPercentage: "Percentage",
      percentageLivePreview:
        "That’s {{amount}} today. It locks in when the invoice is generated.",
      percentageLocksOnSave:
        "The current value appears once this payment is saved.",
      percentageNoValue:
        "The contract value isn’t known yet, so this can’t be priced.",
      fieldAutoSend: "Automatically Send This Invoice to the Client",
      autoSendHelp:
        "The invoice will be emailed to the client on its issue date without further review.",
      save: "Save Payment",
      cancelAction: "Cancel",
      descriptionRequired: "Enter a description of 255 characters or fewer.",
      amountInvalid: "Enter an amount greater than zero.",
      percentageInvalid: "Enter a percentage between 0 and 100.",
      dueDateRequired: "Choose a due date.",
      saveFailed:
        "Sorry, this payment could not be saved due to an error on our end. Please try again later.",
      statusGenerated: "Invoiced",
      statusCancelled: "Cancelled",
      autoSendBadge: "Emails automatically",
      lockedIn: "Locked in when the invoice was raised.",
      locksOnGenerate: "Locks in when the invoice is generated.",
      rowMenuLabel: "Scheduled payment actions",
      viewInvoice: "View Invoice",
      edit: "Edit Payment",
      generate: "Generate Now",
      cancelPayment: "Cancel Payment",
      deletePayment: "Delete Payment",
      menuNotExecuted: "Available once every signer has signed.",
      menuAlreadyInvoiced: "This payment has already been invoiced.",
      menuCancelled: "This payment is cancelled.",
      menuVoided: "This contract is voided.",
      menuNoInvoiceYet: "No invoice has been raised yet.",
      cancelBody:
        "Are you sure you want to cancel this scheduled payment? It will stop counting toward the schedule and no invoice will be raised for it.",
      deleteBody: "Are you sure you want to delete this scheduled payment?",
      generateTitle: "Generate Invoice",
      generateSubtitle: "Review this before the invoice is raised.",
      generateAmount: "Amount",
      generateClient: "Client",
      generateDueDate: "Invoice Due",
      generateDelivery: "Delivery",
      generateWillEmail: "This invoice will be emailed to the client.",
      generateWillNotEmail:
        "This invoice will not be emailed. You can send it from the invoice.",
      generateFailed:
        "Sorry, this invoice could not be generated due to an error on our end. Please try again later.",
      emptyTitle: "No payments scheduled yet",
      emptyBody:
        "Add the first one to say when this contract bills. Invup raises the invoices ahead of time so you don’t have to watch them.",
      blockedBodyNoClient: "A scheduled payment needs a client to invoice.",
      blockedBodyNoCurrency: "A scheduled payment needs a currency to bill in.",
      blockedBodyNeither:
        "A scheduled payment needs a client to invoice and a currency to bill in.",
      loadFailed: "We couldn’t load the payment schedule",
      loadFailedBody: "Sorry, this happened on our end. Try again in a moment.",
    },
    burndown: {
      title: "Billing Progress",
      value: "Contract Value",
      scheduled: "Scheduled",
      unscheduled: "Not Scheduled",
      invoiced: "Invoiced",
      paid: "Paid",
      outstanding: "Outstanding",
      overScheduled: "Over-scheduled",
      emptyTitle: "Nothing to bill yet",
      emptyBody:
        "Billing progress appears once this contract has a currency and a value.",
      unavailableTitle: "Billing progress unavailable",
      unavailableBody:
        "Something on this contract is in a different currency, so the billing progress can’t be worked out. Other sections may still show figures they can total on their own. Contact support to have it corrected.",
      loadFailed: "We couldn’t load the billing progress",
      loadFailedBody: "Sorry, this happened on our end. Try again in a moment.",
      meter: {
        paid: "Paid",
        outstanding: "Outstanding",
        share: "({{percent}}%)",
        shareUnderOne: "(<1%)",
        shareOverNinetyNine: "(>99%)",
        total: "of {{amount}} invoiced",
        nothingInvoiced:
          "Nothing invoiced yet. This bar fills as invoices are raised from the schedule.",
        settled: "Everything invoiced has been paid.",
        overpaid: "{{amount}} more has been paid than invoiced.",
      },
    },
    invoices: {
      title: "Generated Invoices",
      columns: {
        invoice: "Invoice",
        issued: "Issued",
        due: "Due",
        amount: "Amount",
        status: "Status",
      },
      statusDraft: "Draft",
      statusSent: "Sent",
      statusPaid: "Paid",
      partiallyPaid: "{{amount}} paid",
      emptyTitle: "No invoices yet",
      emptyBodyPending:
        "Invoices appear here once every signer has signed and a scheduled payment comes due.",
      emptyBodyExecuted:
        "Invoices appear here as the scheduled payments come due.",
      emptyBodyVoided:
        "This contract is voided, so no further invoices will be raised.",
      loadFailed: "We couldn’t load the generated invoices",
      loadFailedBody: "Sorry, this happened on our end. Try again in a moment.",
    },
  },
  contractsDeleted: "Contracts deleted",
  reminderSent: "Reminder sent",
  signerRemoved: "Signer removed",
  fieldRemoved: "Field removed",
  itemRemoved: "Line item removed",
  itemsRemoved: "Line items removed",
  scheduledPaymentRemoved: "Scheduled payment removed",
  scheduledPaymentCancelled: "Scheduled payment cancelled",
  invoiceGenerated: "Invoice generated",
};
